import React from "react";
import Helmet from "react-helmet";
import HeaderImage from "../components/HeaderImage/HeaderImage";
import Eras from "../components/Eras";

const VideosByErasPage = ({data}) => {
  const {
    allMarkdownRemark: {
      group
    },
    videosHeaderImage
  } = data;

  // filter by era client side since apparently you can't filter
  // graphql queries with substrings in arrays?
  const EraTags = group.filter(x => x.fieldValue.toLowerCase().includes("era"));
  
  return (
    <div>
      <Helmet title="Videos By Era" />
      <HeaderImage headerImage={videosHeaderImage} />
      <div className="section">
        <div className="container" style={{paddingTop: "100px"}}>
          <h1 className="title is-1">
            Videos By Era
          </h1>
          <Eras eras={EraTags} data={data} />
        </div>
      </div>
    </div>
  );
};

export default VideosByErasPage;

/* eslint no-undef: "off" */
export const eraImage = graphql`
fragment eraImage on File {
  publicURL
  childImageSharp {
    sizes(maxWidth: 280, maxHeight: 280, toFormat: JPG, quality: 70) {
      src
      ...GatsbyImageSharpSizes
    }
  }
}
`;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query TagsErasQuery {
    allMarkdownRemark(
      limit: 2000
      filter: {frontmatter: {category: {eq: "video"}}}
    ) {
      group(field: frontmatter___tags) {
        fieldValue
        totalCount
      }
    }
    videosHeaderImage: file(relativePath: { eq: "bg/subbed_videos.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 1920) {
          ...GatsbyImageSharpSizes
        }
      }
    }

    candy_pop_hover: file(relativePath: {eq: "era/candy-pop-hover.jpg"}) {
      ...eraImage
    }
    candy_pop: file(relativePath: {eq: "era/candy-pop.jpg"}) {
      ...eraImage
    }
    dance_the_night_away_hover: file(relativePath: {eq: "era/dance-the-night-away-hover.jpg"}) {
      ...eraImage
    }
    dance_the_night_away: file(relativePath: {eq: "era/dance-the-night-away.jpg"}) {
      ...eraImage
    }
    merry_and_happy_hover: file(relativePath: {eq: "era/merry-and-happy-hover.jpg"}) {
      ...eraImage
    }
    merry_and_happy: file(relativePath: {eq: "era/merry-and-happy.jpg"}) {
      ...eraImage
    }
    signal_hover: file(relativePath: {eq: "era/signal-hover.jpg"}) {
      ...eraImage
    }
    signal: file(relativePath: {eq: "era/signal.jpg"}) {
      ...eraImage
    }
    the_story_begins_hover: file(relativePath: {eq: "era/the-story-begins-hover.jpg"}) {
      ...eraImage
    }
    the_story_begins: file(relativePath: {eq: "era/the-story-begins.jpg"}) {
      ...eraImage
    }
    twicecoaster_lane_1_hover: file(relativePath: {eq: "era/twicecoaster-lane-1-hover.jpg"}) {
      ...eraImage
    }
    twicecoaster_lane_1: file(relativePath: {eq: "era/twicecoaster-lane-1.jpg"}) {
      ...eraImage
    }
    twicecoaster_lane_2_hover: file(relativePath: {eq: "era/twicecoaster-lane-2-hover.jpg"}) {
      ...eraImage
    }
    twicecoaster_lane_2: file(relativePath: {eq: "era/twicecoaster-lane-2.jpg"}) {
      ...eraImage
    }
    twicetagram_hover: file(relativePath: {eq: "era/twicetagram-hover.jpg"}) {
      ...eraImage
    }
    twicetagram: file(relativePath: {eq: "era/twicetagram.jpg"}) {
      ...eraImage
    }
    view_all_hover: file(relativePath: {eq: "era/view-all-hover.jpg"}) {
      ...eraImage
    }
    view_all: file(relativePath: {eq: "era/view-all.jpg"}) {
      ...eraImage
    }
    what_is_love_hover: file(relativePath: {eq: "era/what-is-love-hover.jpg"}) {
      ...eraImage
    }
    what_is_love: file(relativePath: {eq: "era/what-is-love.jpg"}) {
      ...eraImage
    }
  }
`;




// WEBPACK FOOTER //
// ./src/pages/videos-by-era.jsx